module.exports = __webpack_public_path__ + "img/qx.1b7dd41c.png";